'use strict';

export class FieldError {
  /**
   * Immutable Field Error Object
   * @param error
   */
  constructor(error) {
    Object.defineProperties(this, {
      field: {enumerable: true, value: error.field},
      code: {enumerable: true, value: error.code},
      rejectedValue: {enumerable: true, value: error.rejectedValue},
      arguments: {enumerable: true, value: error.arguments},
      defaultCode: {enumerable: true, value: error.defaultCode}
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/FieldError.js